module.exports = __webpack_public_path__ + "b53f8fed47262fc662aa1c1e16b2a0a1.png";